<div class="flex px-6 py-3">
  <div class="flex flex-auto justify-start items-center">
    <flx-ai-shortcut
      *ngFor="let shortcut of leftShortcuts"
      [label]="getShortcutConfig(shortcut).label"
      [icons]="getShortcutConfig(shortcut).icons"
    ></flx-ai-shortcut>
  </div>
  <div class="flex flex-auto justify-center items-center">
    <flx-ai-shortcut
      *ngFor="let shortcut of centerShortcuts"
      [label]="getShortcutConfig(shortcut).label"
      [icons]="getShortcutConfig(shortcut).icons"
    ></flx-ai-shortcut>
  </div>
  <div class="flex flex-auto justify-end items-center">
    <flx-ai-shortcut
      *ngFor="let shortcut of rightShortcuts"
      [label]="getShortcutConfig(shortcut).label"
      [icons]="getShortcutConfig(shortcut).icons"
    ></flx-ai-shortcut>
  </div>
</div>
